module.exports = __webpack_public_path__ + "static/media/left-arrow-black.ae57df20.svg";